import * as React from 'react'
import { SearchBox, SearchBoxProps } from '@fluentui/react-components'
import { Container } from './Search.styles'
import useDebounce from '../../hooks/useDebounce'

interface SearchProps {
  searchTerm: string
  setSearchTerm: (term: string) => void
}

const Search: React.FC<SearchProps> = ({ searchTerm, setSearchTerm }) => {
  const [localSearchTerm, setLocalSearchTerm] =
    React.useState<string>(searchTerm)
  const debouncedSearchTerm = useDebounce<string>(localSearchTerm, 500)

  React.useEffect(() => {
    if (debouncedSearchTerm !== searchTerm) {
      setSearchTerm(debouncedSearchTerm)
    }
  }, [debouncedSearchTerm, searchTerm, setSearchTerm])

  const handleSearchChange: SearchBoxProps['onChange'] = (event, data) => {
    setLocalSearchTerm(data.value || '')
  }

  return (
    <Container>
      <SearchBox
        placeholder="Search Models (3 characters min)"
        size="large"
        style={{ minWidth: '100%' }}
        value={localSearchTerm}
        onChange={handleSearchChange}
      />
    </Container>
  )
}

export default Search
